import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { Dropdown, DropdownItem, Text } from '@grupoboticario/flora-react';
import {
  Container,
  Title,
  SidebarWrapper,
  Sidebar,
  SidebarTitle,
} from './styles';

export interface Filters {
  options: any;
  selectedPeriodRecent: string;
  handlePeriodRecent: (id: string) => void;
  period: string;
  setPeriod: any;
}
export const FilterCertificates = ({
  options,
  selectedPeriodRecent,
  handlePeriodRecent,
  period,
  setPeriod,
}: Filters) => {
  return (
    <Container>
      <Title>Períodos</Title>
      <SidebarWrapper>
        <SidebarTitle>Perídos recentes</SidebarTitle>
        <Sidebar>
          <ul>
            {options.map(option => (
              <li
                aria-hidden="true"
                key={option.value}
                onClick={() => handlePeriodRecent(option.value)}
                className={
                  selectedPeriodRecent === option.value ? 'selected' : ''
                }
              >
                <div className="content">
                  {option.label}
                  <ArrowRightIcon />
                </div>
              </li>
            ))}
          </ul>
        </Sidebar>
        <SidebarTitle>Todos os períodos</SidebarTitle>
        <Dropdown
          id="period-dropdown"
          labelText="Selecione um período"
          optionalText=""
          value={period}
          onChange={setPeriod}
        >
          {options?.map(option => (
            <DropdownItem key={option.value} value={option.value}>
              <Text>{option.label}</Text>
            </DropdownItem>
          ))}
        </Dropdown>
      </SidebarWrapper>
    </Container>
  );
};
